import React from 'react';
import PropTypes from 'prop-types';
import { PillText } from '../PillText';
import { HeadingStyled, HeadingWithBadge } from './styles';

export const Heading = ({
  headingText,
  headingLevel,
  paddingTop = 0,
  position = 'left',
  typography = 'headingMastiff',
  backgroundColor = 'background.base',
  badge = '',
}) => {
  typography =
    typeof typography === 'string'
      ? { desktop: typography, mobile: typography }
      : typography;
  return badge.length ? (
    <HeadingWithBadge position={position}>
      <HeadingStyled
        bgColor={backgroundColor}
        as={headingLevel}
        typography={typography}
        position={position}
        paddingTop={paddingTop}
      >
        {headingText}
        &nbsp;
      </HeadingStyled>
      <PillText text={badge} variant="kale" />
    </HeadingWithBadge>
  ) : (
    <HeadingStyled
      bgColor={backgroundColor}
      as={headingLevel}
      typography={typography}
      position={position}
      paddingTop={paddingTop}
    >
      {headingText}
    </HeadingStyled>
  );
};

Heading.displayName = 'Heading';

Heading.propTypes = {
  typography: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      desktop: PropTypes.string,
      mobile: PropTypes.string,
    }),
  ]),
  paddingTop: PropTypes.number,
  headingText: PropTypes.string.isRequired,
  headingLevel: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6'])
    .isRequired,
  position: PropTypes.oneOf(['left', 'right', 'center']),
  backgroundColor: PropTypes.string,
  badge: PropTypes.string,
};
